import * as React from 'react';
import { useContext, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Button, Card, CardBody, CardSubtitle, CardTitle, Col, Form, FormGroup, FormText, Input, Label, Row, Spinner } from 'reactstrap';
import { ErrorContext } from '../../../state';
import {
    IOutstandingDemoDto,
    DemosClient,
    FileParameter,
    FilesClient,
    MarkDemoAsMissingCommand,
} from '../../../WorldDoomLeague';

interface OutstandingDemoListProps {
    demo: IOutstandingDemoDto;
    setChangedDemoId: React.Dispatch<React.SetStateAction<number>>;
}

const OutstandingDemoList = (props: OutstandingDemoListProps) => {
    const error = useContext(ErrorContext);
    const [file, setFile] = useState<FileParameter>();
    const [isUploading, setIsUploading] = useState<boolean>(false);

    const handleSubmit = async (evt) => {
        try {
            let client = new FilesClient();
            setIsUploading(true);
            const response = await client.adminCreateDemoFile(file, props.demo.id);
            props.setChangedDemoId(response);
            setFile(null);
            setIsUploading(false);
        } catch (e) {
            error.setError(JSON.parse(e.response));
            setIsUploading(false);
        }
    };

    const handleUpload = async (evt: React.ChangeEvent<HTMLInputElement>) => {
        const upload: FileParameter = {
            data: evt.target.files[0],
            fileName: evt.target.files[0].name
        };
        setFile(upload);
    };

    return (
        <React.Fragment>
            <Row className='mb-3'>
                <Col>
                    <Card className='border-white mb-3'>
                        <CardBody>
                            <CardTitle tag="h3">{props.demo.gameName}</CardTitle>
                                <h4>Player: <NavLink to={`/player/${props.demo.playerId}`}>{props.demo.playerName}</NavLink></h4>
                                <h4>Team: <NavLink to={`/player/${props.demo.teamId}`}>{props.demo.teamName}</NavLink></h4>
                                <Form>
                                    <FormGroup>
                                        <Label for="File">Zipped Demo Files</Label>
                                        <Input type="file" name="file" id="file" key={props.demo.id} onChange={handleUpload} />
                                        <FormText color="muted" className='mb-3'>
                                            Max upload: 200MB
                                            <br />
                                            All demo files for the game must be included, and all files MUST be zipped.
                                        </FormText>
                                        {isUploading && (
                                            <React.Fragment>
                                                <Spinner color="light" />
                                                <h3>Uploading...</h3>
                                            </React.Fragment>
                                        )}
                                    </FormGroup>
                                </Form>
                                {props.demo.isUploaded && (
                                    <p>Demo File: <NavLink to={props.demo.demoLink}>Download</NavLink></p>
                                )}
                                
                                {!props.demo.isUploaded && (
                                    <p className='text-danger'>Player has yet to upload the demo.</p>
                                )}
                                
                                {props.demo.playerLostDemo && (
                                    <p className='text-danger'>Player lost the demo file.</p>
                                )}
                                {!props.demo.demoAdminApproved && (
                                    <p className='text-danger'>This demo has not yet been approved.</p>
                                )}
                                <div className="clearfix">
                                    <Button color="primary" size="lg" className='float-left' disabled={!file} onClick={handleSubmit}>Upload Demo</Button>
                                </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default OutstandingDemoList;